import { createContext } from 'react';

/**
 * Which concept a page is, like "Concept 1", for the last step of its
 * breadcrumb, the way a versioned page shows its version. Set by the routes from
 * the manifest's Concepts lists, so the number is the page's place in its
 * section's list and the menu and the breadcrumb cannot disagree.
 */
export const ConceptTag = createContext<string | null>(null);
